import { render, staticRenderFns } from "./FlowUpdateBk.vue?vue&type=template&id=743c3f2f&"
import script from "./FlowUpdateBk.vue?vue&type=script&lang=js&"
export * from "./FlowUpdateBk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports